import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import { ProxyTypeEnum } from '../interfaces/proxy-type-enum';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/MWHR43/MWHR43_QuickQuiz_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    ButtonURL: 'Quick-Quiz',
    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      "<p>Test yourself on the Maths Skills you\'ll need to help with each Paper.</p>\n" +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every topic',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Worked Solutions',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/MWHR43/MWHR43_Mistakes_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here &mdash; have another go and conquer them once and for all!</p>\n' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers\n',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Worked Solutions',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.ExamSkillsVideos,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    MixedOnlineTests: [],

    ButtonURL: 'videos',
    HasData: false,
    HeadingText: 'Worked Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Learn how to answer the exam-style questions in your book</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Worked Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Section One',
            Subcategories: [
              {
                Name: 'Number — 1',
                ShortName: '',
                Link: '',
              },
              {
                Name: 'Dividing Whole Numbers',
                ShortName: 'Dividing-Whole-Numbers',
                Link: 'https://www.youtube.com/embed/VGG7YZtxdo4?rel=0&modestbranding=1',
              },
              {
                Name: 'Dividing Decimals',
                ShortName: 'Dividing-Decimals',
                Link: 'https://www.youtube.com/embed/DJQjzeweq7E?rel=0&modestbranding=1',
              },
              {
                Name: 'Rounding - Significant Figures',
                ShortName: 'Rounding-Significant-Figures',
                Link: 'https://www.youtube.com/embed/toGvZ1C_-tI?rel=0&modestbranding=1',
              },
              {
                Name: 'Calculating with Bounds',
                ShortName: 'Calculating-with-Bounds',
                Link: 'https://www.youtube.com/embed/b8JoNaeHrB8?rel=0&modestbranding=1',
              },
              {
                Name: 'Finding Prime Factorisations',
                ShortName: 'Finding-Prime-Factorisations',
                Link: 'https://www.youtube.com/embed/_iuIq062n64?rel=0&modestbranding=1',
              },
              {
                Name: 'Finding the Lowest Common Multiple',
                ShortName: 'Finding-the-Lowest-Common-Multiple',
                Link: 'https://www.youtube.com/embed/FYdlj39HktA?rel=0&modestbranding=1',
              },
              {
                Name: 'Fraction Problems',
                ShortName: 'Fraction-Problems',
                Link: 'https://www.youtube.com/embed/GaCqLPbB_s8?rel=0&modestbranding=1',
              },
              {
                Name: 'Turning Recurring Decimals into Fractions',
                ShortName: 'Turning-Recurring-Decimals-into-Fractions',
                Link: 'https://www.youtube.com/embed/l2z2X7eQQtU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: '',
            Subcategories: [
              {
                Name: 'Number — 2',
                ShortName: '',
                Link: '',
              },
              {
                Name: 'Percentages - Finding the Original Value',
                ShortName: 'Percentages-Finding-the-Original-Value',
                Link: 'https://www.youtube.com/embed/fW_eIsJjCEU?rel=0&modestbranding=1',
              },
              {
                Name: 'Working with Percentages',
                ShortName: 'Working-with-Percentages',
                Link: 'https://www.youtube.com/embed/9QX_4QeidvA?rel=0&modestbranding=1',
              },
              {
                Name: 'Compound Interest',
                ShortName: 'Compound-Interest',
                Link: 'https://www.youtube.com/embed/YAChcgPGX8E?rel=0&modestbranding=1',
              },
              {
                Name: 'Ratios',
                ShortName: 'Ratios',
                Link: 'https://www.youtube.com/embed/C4PbyaFh698?rel=0&modestbranding=1',
              },
              {
                Name: 'Direct Proportion',
                ShortName: 'Direct-Proportion',
                Link: 'https://www.youtube.com/embed/ayyi7IoMf4o?rel=0&modestbranding=1',
              },
              {
                Name: 'Working with Powers',
                ShortName: 'Working-with-Powers',
                Link: 'https://www.youtube.com/embed/F9a5mZTkZno?rel=0&modestbranding=1',
              },
              {
                Name: 'Standard Form',
                ShortName: 'Standard-Form',
                Link: 'https://www.youtube.com/embed/ZZlmQnE5Cco?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Two',
            Subcategories: [
              {
                Name: 'Algebra — 1',
                ShortName: '',
                Link: '',
              },
              {
                Name: 'Multiplying Out Brackets',
                ShortName: 'Multiplying-Out-Brackets',
                Link: 'https://www.youtube.com/embed/PYrJBfZTc08?rel=0&modestbranding=1',
              },
              {
                Name: 'The Difference of Two Squares',
                ShortName: 'The-Difference-of-Two-Squares',
                Link: 'https://www.youtube.com/embed/nV_d9Rl34IU?rel=0&modestbranding=1',
              },
              {
                Name: 'Solving Equations',
                ShortName: 'Solving-Equations',
                Link: 'https://www.youtube.com/embed/FAvRn0AKf-8?rel=0&modestbranding=1',
              },
              {
                Name: 'Forming Equations from Words',
                ShortName: 'Forming-Equations-from-Words',
                Link: 'https://www.youtube.com/embed/069Q6Q6ivCc?rel=0&modestbranding=1',
              },
              {
                Name: 'Rearranging Formulas',
                ShortName: 'Rearranging-Formulas',
                Link: 'https://www.youtube.com/embed/PEvbrP6MAJg?rel=0&modestbranding=1',
              },
              {
                Name: 'Factorising Quadratics',
                ShortName: 'Factorising-Quadratics',
                Link: 'https://www.youtube.com/embed/75eqQjsicQU?rel=0&modestbranding=1',
              },
              {
                Name: 'Algebraic Fractions',
                ShortName: 'Algebraic-Fractions',
                Link: 'https://www.youtube.com/embed/vB6IJYry6O4?rel=0&modestbranding=1',
              },
            ],
          },

          {
            Header: '',
            Subcategories: [
              {
                Name: 'Algebra — 2',
                ShortName: '',
                Link: '',
              },
              {
                Name: 'Graphical Inequalities',
                ShortName: 'Graphical-Inequalities',
                Link: 'https://www.youtube.com/embed/XF35-pgqPFs?rel=0&modestbranding=1',
              },
              {
                Name: 'Simultaneous Equations',
                ShortName: 'Simultaneous-Equations',
                Link: 'https://www.youtube.com/embed/rb6w96UDFZY?rel=0&modestbranding=1',
              },
              {
                Name: 'Wordy Simultaneous Equations',
                ShortName: 'Wordy-Simultaneous-Equations',
                Link: 'https://www.youtube.com/embed/mEA0d3fSryk?rel=0&modestbranding=1',
              },
              {
                Name: 'Coordinates and Midpoints',
                ShortName: 'Coordinates-and-Midpoints',
                Link: 'https://www.youtube.com/embed/OjuOGIDwbqI?rel=0&modestbranding=1',
              },
              {
                Name: 'Finding the Equations of Parallel Lines',
                ShortName: 'Finding-the-Equations-of-Parallel-Lines',
                Link: 'https://www.youtube.com/embed/rbiV0AkrKm8?rel=0&modestbranding=1',
              },
              {
                Name: 'Drawing Quadratic Graphs',
                ShortName: 'Drawing-Quadratic-Graphs',
                Link: 'https://www.youtube.com/embed/neO0eZbIJpQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Using Distance-Time Graphs',
                ShortName: 'Using-Distance-Time-Graphs',
                Link: 'https://www.youtube.com/embed/sz3ubmzH0zo?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Section Three',
            Subcategories: [
              {
                Name: 'Geometry and Measures — 1',
                ShortName: '',
                Link: '',
              },
              {
                Name: 'Symmetry',
                ShortName: 'Symmetry',
                Link: 'https://www.youtube.com/embed/QKGxR3xl1Zc?rel=0&modestbranding=1',
              },
              {
                Name: 'Finding Interior Angles in a Polygon',
                ShortName: 'Finding-Interior-Angles-in-a-Polygon',
                Link: 'https://www.youtube.com/embed/BjYzeBZc-DU?rel=0&modestbranding=1',
              },
              {
                Name: 'Similar Shapes',
                ShortName: 'Similar-Shapes',
                Link: 'https://www.youtube.com/embed/D9Qsd2XHWZg?rel=0&modestbranding=1',
              },
              {
                Name: 'Transformations',
                ShortName: 'Transformations',
                Link: 'https://www.youtube.com/embed/vQz8nGVA9ew?rel=0&modestbranding=1',
              },
              {
                Name: 'Area Problems',
                ShortName: 'Area-Problems',
                Link: 'https://www.youtube.com/embed/l0S1a4quBMg?rel=0&modestbranding=1',
              },
              {
                Name: 'Sectors, Segments and Arcs',
                ShortName: 'Sectors-Segments-and-Arcs',
                Link: 'https://www.youtube.com/embed/BeWKUgOB0xY?rel=0&modestbranding=1',
              },
              {
                Name: 'Surface Area of a Sphere',
                ShortName: 'Surface-Area-of-a-Sphere',
                Link: 'https://www.youtube.com/embed/qegSmCvNj5M?rel=0&modestbranding=1',
              },
              {
                Name: 'Volumes of 3D Shapes',
                ShortName: 'Volumes-of-3D-Shapes',
                Link: 'https://www.youtube.com/embed/XwBtaXvBJEM?rel=0&modestbranding=1',
              },
              {
                Name: 'Time Problems',
                ShortName: 'Time-Problems',
                Link: 'https://www.youtube.com/embed/ku0-rwAwTLc?rel=0&modestbranding=1',
              },
              {
                Name: 'Converting Units',
                ShortName: 'Converting-Units',
                Link: 'https://www.youtube.com/embed/sdkMCuo4wMo?rel=0&modestbranding=1',
              },
              {
                Name: 'Density',
                ShortName: 'Density',
                Link: 'https://www.youtube.com/embed/we4ZTtOYrbc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: '',
            Subcategories: [
              {
                Name: 'Geometry and Measures — 2',
                ShortName: '',
                Link: '',
              },
              {
                Name: 'Circle Theorems',
                ShortName: 'Circle-Theorems',
                Link: 'https://www.youtube.com/embed/47jtc16HM3U?rel=0&modestbranding=1',
              },
              {
                Name: 'Triangle Construction',
                ShortName: 'Triangle-Construction',
                Link: 'https://www.youtube.com/embed/vlGBM4is22A?rel=0&modestbranding=1',
              },
              {
                Name: 'Loci',
                ShortName: 'Loci',
                Link: 'https://www.youtube.com/embed/Nq5l_mLHD4M?rel=0&modestbranding=1',
              },
              {
                Name: 'Bearings',
                ShortName: 'Bearings',
                Link: 'https://www.youtube.com/embed/L-jVmitnMZU?rel=0&modestbranding=1',
              },
              {
                Name: 'Maps and Scale Drawings',
                ShortName: 'Maps-and-Scale-Drawings',
                Link: 'https://www.youtube.com/embed/MEFAtIqFQlI?rel=0&modestbranding=1',
              },
              {
                Name: "Pythagoras' Theorem",
                ShortName: 'Pythagoras-Theorem',
                Link: 'https://www.youtube.com/embed/S0WI-k2h2nQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Trigonometry',
                ShortName: 'Trigonometry',
                Link: 'https://www.youtube.com/embed/B9QCSPyHjdg?rel=0&modestbranding=1',
              },
              {
                Name: 'The Sine and Cosine Rules',
                ShortName: 'The-Sine-and-Cosine-Rules',
                Link: 'https://www.youtube.com/embed/OsqETT6W_Eg?rel=0&modestbranding=1',
              },
              {
                Name: '3D Trigonometry',
                ShortName: '3D-Trigonometry',
                Link: 'https://www.youtube.com/embed/JsAayXd1V5c?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Section Four',
            Subcategories: [
              {
                Name: 'Statistics and Probability — 1',
                ShortName: '',
                Link: '',
              },
              {
                Name: 'Stratified Sampling',
                ShortName: 'Stratified-Sampling',
                Link: 'https://www.youtube.com/embed/GHDKAiKkRgA?rel=0&modestbranding=1',
              },
              {
                Name: 'Mean, Median, Mode and Range',
                ShortName: 'Mean-Median-Mode-and-Range',
                Link: 'https://www.youtube.com/embed/Q2BM8D9tYOY?rel=0&modestbranding=1',
              },
              {
                Name: 'Pictograms',
                ShortName: 'Pictograms',
                Link: 'https://www.youtube.com/embed/7XL9TuFASmE?rel=0&modestbranding=1',
              },
              {
                Name: 'Drawing Pie Charts',
                ShortName: 'Drawing-Pie-Charts',
                Link: 'https://www.youtube.com/embed/NFBdej_-JaQ?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: '',
            Subcategories: [
              {
                Name: 'Statistics and Probability — 2',
                ShortName: '',
                Link: '',
              },
              {
                Name: 'Finding Averages from Frequency Tables',
                ShortName: 'Finding-Averages-from-Frequency-Tables',
                Link: 'https://www.youtube.com/embed/-wzFgvH2Jao?rel=0&modestbranding=1',
              },
              {
                Name: 'Box and Whisker Diagrams',
                ShortName: 'Box-and-Whisker-Diagrams',
                Link: 'https://www.youtube.com/embed/GH414GLCLEY?rel=0&modestbranding=1',
              },
              {
                Name: 'Histograms',
                ShortName: 'Histograms',
                Link: 'https://www.youtube.com/embed/5Zxt31QICz8?rel=0&modestbranding=1',
              },
              {
                Name: 'Probability - Counting Outcomes',
                ShortName: 'Probability-Counting-Outcomes',
                Link: 'https://www.youtube.com/embed/Ow2TjFUjQ7U?rel=0&modestbranding=1',
              },
              {
                Name: 'Probability Experiments',
                ShortName: 'Probability-Experiments',
                Link: 'https://www.youtube.com/embed/vYvkKkdbOH4?rel=0&modestbranding=1',
              },
              {
                Name: 'Tree Diagrams',
                ShortName: 'Tree-Diagrams',
                Link: 'https://www.youtube.com/embed/khUtJV_byXI?rel=0&modestbranding=1',
              },
              {
                Name: 'Venn Diagrams',
                ShortName: 'Venn-Diagrams',
                Link: 'https://www.youtube.com/embed/HG3ytOFTVHQ?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Worked Solutions',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Worked Solutions',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: "<p>Worked Answers and Unit Map... yep, it\'s all right here.</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<p>Your Worked Answers and Unit&nbsp;Map are below. Take your pick!</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MWHR43/PDFs/cgp-gcse-wjec-maths-workedanswers.pdf" target="_blank">Worked Answers</a></p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MWHR43/PDFs/cgp-gcse-wjec-maths-unitmap.pdf" target="_blank">Unit Map</a></p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Worked Solutions',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.HighFoundationSwitch,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#288B31',
    ButtonCustomClasses: '',
    ButtonText: 'Switch',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Higher or Foundation',
    IsButtonDisabled: false,
    IsSwitcher: true,
    MainContentText: function () {
      if (typeof document !== 'undefined') {
        const match = document.cookie.match(/(?:^|; )CgpDigitalRevision=([^;]*)/);
        const value = match ? decodeURIComponent(match[1]) : '';
        if (value === 'Foundation') {
          return `<p>You&#39;re working at <strong>Foundation Level</strong></p>\n\n<p>Switch to <strong>Higher Level</strong>?</p>`;
        }
        if (value === 'Higher') {
          return `<p>You&#39;re working at <strong>Higher Level</strong></p><p>Switch to <strong>Foundation Level</strong>?</p>`;
        }
      }
      return '';
    },

    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Choose your exam level',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Worked Solutions',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#D50200',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: "<p>We\'ve answered some of the questions you might have.</p>\n",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        'We’ve put together lots of helpful information on how to get the most out of your Revision Guide. And if you’ve hit any snags, you’ll find the answers you need here too.',
      Text:
        '<h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5>What is CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Maths books. Use the quizzes and videos to revise what you’ve learned from your book and practise for the exams.&nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I access CGP RevisionHub?</h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig so you can practise exactly what you've just learned!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>My RevisionHub isn’t working — what do I do?&nbsp;</h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact" style="color: #1494D4;">Customer Services team</a>.&nbsp;&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Do I need an internet connection to use CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also&nbsp;useful bits that you can download as PDFs to access offline. Phew.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>If I log in on a different device, will all my progress be saved?&nbsp;</h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What’s the difference between the Quick Quizzes and Your Mistakes Quiz?</h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on every topic on the course. There's one on almost every section of your book — we're generous like that.</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>What happens when I switch between Higher and Foundation level?</h5>\n' +
        '\n' +
        "<p>You can switch between Higher and Foundation level as much as you want. When you're using Foundation level, you won't be able to see any Higher level quiz questions. But don't worry — all your progress and scores from Higher level will still be saved.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I clear my progress so far in the Hub and start again?&nbsp;</h5>\n' +
        '\n' +
        "<p>There are no takie-backsies in CGP RevisionHub, so you can't clear your results and start again. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores.&nbsp;Keep going, we believe in you!<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Can I share my quiz scores and test results with other people?&nbsp;</h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5>Will I always have access to CGP RevisionHub?&nbsp;</h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise.<br>\n" +
        '&nbsp;</p>',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Worked Solutions',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from. Take a look at some of our other books!",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
      },
      {
        Text: 'Worked Solutions',
        ImagePath: '/assets/images/landing/exam-skills-videos.png',
        DestinationPage: 'Videos',
      },
      {
        Text: 'Level',
        ImagePath: '/assets/images/landing/h-f-level.png',
        DestinationPage: 'CookieSwitcher',
      },
    ],
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
];

